import SEOHead from '../../components/base/SEOHead';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesGrid from './components/ServicesGrid';
import TestimonialSection from './components/TestimonialSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const HomePage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const schema = {
    "@context": "https://schema.org",
    "@type": "AutoRepair",
    "name": "Brooklyn Auto Body Shop",
    "image": "https://public.readdy.ai/ai/img_res/a2998240-751c-41d3-bad2-d3267e63c20f.png",
    "@id": siteUrl,
    "url": siteUrl,
    "telephone": "+16319337887",
    "email": "info@brooklynautobody.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Brooklyn Industrial Area",
      "addressLocality": "Brooklyn",
      "addressRegion": "NY",
      "postalCode": "11201",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 40.6782,
      "longitude": -73.9442
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "08:00",
        "closes": "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "09:00",
        "closes": "15:00"
      }
    ],
    "priceRange": "$$",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "127"
    },
    "sameAs": [
      "https://facebook.com",
      "https://instagram.com"
    ]
  };

  return (
    <>
      <SEOHead
        title="Brooklyn Auto Body Shop - Expert Auto Repair & Collision Services in NY"
        description="Brooklyn's trusted auto body shop with 30+ years of experience. Expert collision repair, paint & body work, mechanical services in Brooklyn, NY. Work with all insurance companies. Free estimates."
        keywords="New York auto repair, Brooklyn body shop, accident repair, car maintenance, roadside assistance, insurance repairs, warranty work, experienced mechanics, quality work, reliable body shop"
        canonical={`${siteUrl}/`}
        ogTitle="Brooklyn Auto Body Shop - Expert Auto Repair & Collision Services"
        ogDescription="Brooklyn's trusted auto body shop with 30+ years of experience. Expert collision repair, paint & body work, mechanical services."
        ogImage="https://public.readdy.ai/ai/img_res/a2998240-751c-41d3-bad2-d3267e63c20f.png"
        geoPosition="40.6782;-73.9442"
        geoPlacename="Brooklyn, NY"
        geoRegion="US-NY"
        lastModified={new Date().toISOString()}
        schema={schema}
      />
      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar />
        <main>
          <HeroSection />
          <ServicesGrid />
          <TestimonialSection />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default HomePage;
